import http from 'conversations-http/clients/http';
export const fetchMessengerConnections = () => http.get('facebook-messenger/v1/connection/all');